import {} from "react";

import useFixniPozadavky from "./useFixniPozadavky";

import { useFieldValue } from "2g-form/hooks";
import { useAuthProvider } from "2g-auth";

export default function useFixniPozadavkyBoxError({ moduleKey }) {
  const projekt = useFieldValue("projekt", moduleKey);
  const { userInfo } = useAuthProvider();
  const { faze, ...fixniPozadavky } = useFixniPozadavky();
  return {
    ...fixniPozadavky,
    faze,
    isError:
      userInfo.isUserInRole("zakaznik") &&
      faze &&
      !faze.vsechny &&
      (!faze.fixni ||
        (faze.fixni &&
          projekt?.smlouva.fixMo == 0 &&
          projekt?.smlouva.fixVo == 0))
  };
}
